module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated",
    class: {
      slideInDown: _vm.show,
      slideOutDown: !_vm.show
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    staticClass: "nav-item is-hidden-tablet",
    on: {
      "click": function($event) {
        return _vm.$store.dispatch('TOGGLE_SIDEBAR')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "nav-center"
  }, [_c('a', {
    staticClass: "nav-item hero-brand",
    attrs: {
      "href": "./"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/ezlink.png"),
      "alt": _vm.description
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "nav-right is-flex",
    staticStyle: {
      "padding-right": "40px"
    }
  }, [(_vm.$store.state.config.logged && _vm.$store.state.config.user) ? [_c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openNotifications()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell",
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v(_vm._s(_vm.$store.state.config.hasOwnProperty('notifications') ? _vm.$store.state.config.notifications.length : 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_vm._v(_vm._s(_vm.$store.state.config.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('tooltip', {
    attrs: {
      "label": "Logout",
      "type": "default",
      "placement": "left"
    }
  }, [_c('a', {
    staticClass: "logout",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])])], 1)] : _vm._e()], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "is-hidden-mobile"
  }, [_c('strong', {
    staticClass: "ezlink"
  }, [_vm._v("EZ Link")]), _vm._v(" "), _c('span', {
    staticClass: "customer"
  }, [_vm._v("Customer Relations")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9f8bafe","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/Navbar.vue
// module id = 1207
// module chunks = 39